/**
 * Shared microcopy (footer, common CTAs, generic strings).
 *
 * Re-export shim over the cross-platform source of truth at
 * /locales/{en,ht,fr,es}.json. The shape stays identical to what
 * pages already import — { en, ht, fr, es } — so page code doesn't
 * change.
 *
 * See /locales/README.md for why the source lives at the repo root
 * (iOS + Android consume the same JSON files at build time via
 * platform-specific converters).
 */
import en from '../locales-shared/en.json'
import ht from '../locales-shared/ht.json'
import fr from '../locales-shared/fr.json'
import es from '../locales-shared/es.json'
import ptBR from '../locales-shared/pt-BR.json'
import zhHans from '../locales-shared/zh-Hans.json'

const COPY = {
  en: en.shared,
  ht: ht.shared,
  fr: fr.shared,
  es: es.shared,
  'pt-BR': ptBR.shared,
  'zh-Hans': zhHans.shared,
}

export default COPY
